module.exports = __webpack_public_path__ + "static/media/sf_restaurant_11.f1362111.jpg";